export default {
    topics: [
        {
            title: ' PKSequence ',
            href: 'p-SchemaNode-PKSequence.html',
            attributes: { 'data-id': 'p-SchemaNode-PKSequence' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-PKSequence-d66e6071',
            topics: [],
        },
        {
            title: ' SQLName ',
            href: 'p-SchemaNode-SQLName.html',
            attributes: { 'data-id': 'p-SchemaNode-SQLName' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-SQLName-d66e6079',
            topics: [],
        },
        {
            title: ' SQLTable ',
            href: 'p-SchemaNode-SQLTable.html',
            attributes: { 'data-id': 'p-SchemaNode-SQLTable' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-SQLTable-d66e6087',
            topics: [],
        },
        {
            title: ' children ',
            href: 'p-SchemaNode-children.html',
            attributes: { 'data-id': 'p-SchemaNode-children' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-children-d66e6095',
            topics: [],
        },
        {
            title: ' childrenCount ',
            href: 'p-SchemaNode-childrenCount.html',
            attributes: { 'data-id': 'p-SchemaNode-childrenCount' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-childrenCount-d66e6103',
            topics: [],
        },
        {
            title: ' computeString ',
            href: 'p-SchemaNode-computeString.html',
            attributes: { 'data-id': 'p-SchemaNode-computeString' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-computeString-d66e6111',
            topics: [],
        },
        {
            title: ' dataPolicy ',
            href: 'p-SchemaNode-dataPolicy.html',
            attributes: { 'data-id': 'p-SchemaNode-dataPolicy' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-dataPolicy-d66e6119',
            topics: [],
        },
        {
            title: ' defaultValue ',
            href: 'p-SchemaNode-defaultValue.html',
            attributes: { 'data-id': 'p-SchemaNode-defaultValue' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-defaultValue-d66e6127',
            topics: [],
        },
        {
            title: ' description ',
            href: 'p-SchemaNode-description.html',
            attributes: { 'data-id': 'p-SchemaNode-description' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-description-d66e6135',
            topics: [],
        },
        {
            title: ' editType ',
            href: 'p-SchemaNode-editType.html',
            attributes: { 'data-id': 'p-SchemaNode-editType' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-editType-d66e6143',
            topics: [],
        },
        {
            title: ' enumeration ',
            href: 'p-SchemaNode-enumeration.html',
            attributes: { 'data-id': 'p-SchemaNode-enumeration' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-enumeration-d66e6152',
            topics: [],
        },
        {
            title: ' enumerationImage ',
            href: 'p-SchemaNode-enumerationImage.html',
            attributes: { 'data-id': 'p-SchemaNode-enumerationImage' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-enumerationImage-d66e6160',
            topics: [],
        },
        {
            title: ' findNode ',
            href: 'm-SchemaNode-findNode.html',
            attributes: { 'data-id': 'm-SchemaNode-findNode' },
            menu: { hasChildren: false },
            tocID: 'm-SchemaNode-findNode-d66e6168',
            topics: [],
        },
        {
            title: ' folderModel ',
            href: 'p-SchemaNode-folderModel.html',
            attributes: { 'data-id': 'p-SchemaNode-folderModel' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-folderModel-d66e6176',
            topics: [],
        },
        {
            title: ' hasEnumeration ',
            href: 'p-SchemaNode-hasEnumeration.html',
            attributes: { 'data-id': 'p-SchemaNode-hasEnumeration' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-hasEnumeration-d66e6184',
            topics: [],
        },
        {
            title: ' hasSQLTable ',
            href: 'p-SchemaNode-hasSQLTable.html',
            attributes: { 'data-id': 'p-SchemaNode-hasSQLTable' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-hasSQLTable-d66e6192',
            topics: [],
        },
        {
            title: ' hasUserEnumeration ',
            href: 'p-SchemaNode-hasUserEnumeration.html',
            attributes: { 'data-id': 'p-SchemaNode-hasUserEnumeration' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-hasUserEnumeration-d66e6200',
            topics: [],
        },
        {
            title: ' help ',
            href: 'p-SchemaNode-help.html',
            attributes: { 'data-id': 'p-SchemaNode-help' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-help-d66e6208',
            topics: [],
        },
        {
            title: ' image ',
            href: 'p-SchemaNode-image.html',
            attributes: { 'data-id': 'p-SchemaNode-image' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-image-d66e6216',
            topics: [],
        },
        {
            title: ' integrity ',
            href: 'p-SchemaNode-integrity.html',
            attributes: { 'data-id': 'p-SchemaNode-integrity' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-integrity-d66e6224',
            topics: [],
        },
        {
            title: ' isAdvanced ',
            href: 'p-SchemaNode-isAdvanced.html',
            attributes: { 'data-id': 'p-SchemaNode-isAdvanced' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isAdvanced-d66e6232',
            topics: [],
        },
        {
            title: ' isAnyType ',
            href: 'p-SchemaNode-isAnyType.html',
            attributes: { 'data-id': 'p-SchemaNode-isAnyType' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isAnyType-d66e6241',
            topics: [],
        },
        {
            title: ' isAttribute ',
            href: 'p-SchemaNode-isAttribute.html',
            attributes: { 'data-id': 'p-SchemaNode-isAttribute' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isAttribute-d66e6249',
            topics: [],
        },
        {
            title: ' isAutoIncrement ',
            href: 'p-SchemaNode-isAutoIncrement.html',
            attributes: { 'data-id': 'p-SchemaNode-isAutoIncrement' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isAutoIncrement-d66e6257',
            topics: [],
        },
        {
            title: ' isAutoPK ',
            href: 'p-SchemaNode-isAutoPK.html',
            attributes: { 'data-id': 'p-SchemaNode-isAutoPK' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isAutoPK-d66e6265',
            topics: [],
        },
        {
            title: ' isBlob ',
            href: 'p-SchemaNode-isBlob.html',
            attributes: { 'data-id': 'p-SchemaNode-isBlob' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isBlob-d66e6273',
            topics: [],
        },
        {
            title: ' isCDATA ',
            href: 'p-SchemaNode-isCDATA.html',
            attributes: { 'data-id': 'p-SchemaNode-isCDATA' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isCDATA-d66e6281',
            topics: [],
        },
        {
            title: ' isCalculated ',
            href: 'p-SchemaNode-isCalculated.html',
            attributes: { 'data-id': 'p-SchemaNode-isCalculated' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isCalculated-d66e6289',
            topics: [],
        },
        {
            title: ' isCollection ',
            href: 'p-SchemaNode-isCollection.html',
            attributes: { 'data-id': 'p-SchemaNode-isCollection' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isCollection-d66e6297',
            topics: [],
        },
        {
            title: ' isDefaultOnDuplicate ',
            href: 'p-SchemaNode-isDefaultOnDuplicate.html',
            attributes: { 'data-id': 'p-SchemaNode-isDefaultOnDuplicate' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isDefaultOnDuplicate-d66e6305',
            topics: [],
        },
        {
            title: ' isElementOnly ',
            href: 'p-SchemaNode-isElementOnly.html',
            attributes: { 'data-id': 'p-SchemaNode-isElementOnly' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isElementOnly-d66e6313',
            topics: [],
        },
        {
            title: ' isExternalJoin ',
            href: 'p-SchemaNode-isExternalJoin.html',
            attributes: { 'data-id': 'p-SchemaNode-isExternalJoin' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isExternalJoin-d66e6321',
            topics: [],
        },
        {
            title: ' isFeature ',
            href: 'p-SchemaNode-isFeature.html',
            attributes: { 'data-id': 'p-SchemaNode-isFeature' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isFeature-d66e6330',
            topics: [],
        },
        {
            title: ' isLink ',
            href: 'p-SchemaNode-isLink.html',
            attributes: { 'data-id': 'p-SchemaNode-isLink' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isLink-d66e6338',
            topics: [],
        },
        {
            title: ' isMappedAsXML ',
            href: 'p-SchemaNode-isMappedAsXML.html',
            attributes: { 'data-id': 'p-SchemaNode-isMappedAsXML' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isMappedAsXML-d66e6346',
            topics: [],
        },
        {
            title: ' isMemo ',
            href: 'p-SchemaNode-isMemo.html',
            attributes: { 'data-id': 'p-SchemaNode-isMemo' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isMemo-d66e6354',
            topics: [],
        },
        {
            title: ' isMemoData ',
            href: 'p-SchemaNode-isMemoData.html',
            attributes: { 'data-id': 'p-SchemaNode-isMemoData' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isMemoData-d66e6362',
            topics: [],
        },
        {
            title: ' isNotNull ',
            href: 'p-SchemaNode-isNotNull.html',
            attributes: { 'data-id': 'p-SchemaNode-isNotNull' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isNotNull-d66e6370',
            topics: [],
        },
        {
            title: ' isRequired ',
            href: 'p-SchemaNode-isRequired.html',
            attributes: { 'data-id': 'p-SchemaNode-isRequired' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isRequired-d66e6378',
            topics: [],
        },
        {
            title: ' isRoot ',
            href: 'p-SchemaNode-isRoot.html',
            attributes: { 'data-id': 'p-SchemaNode-isRoot' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isRoot-d66e6386',
            topics: [],
        },
        {
            title: ' isSQL ',
            href: 'p-SchemaNode-isSQL.html',
            attributes: { 'data-id': 'p-SchemaNode-isSQL' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isSQL-d66e6394',
            topics: [],
        },
        {
            title: ' isTemporaryTable ',
            href: 'p-SchemaNode-isTemporaryTable.html',
            attributes: { 'data-id': 'p-SchemaNode-isTemporaryTable' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isTemporaryTable-d66e6402',
            topics: [],
        },
        {
            title: ' isUnbound ',
            href: 'p-SchemaNode-isUnbound.html',
            attributes: { 'data-id': 'p-SchemaNode-isUnbound' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isUnbound-d66e6410',
            topics: [],
        },
        {
            title: ' isUser ',
            href: 'p-SchemaNode-isUser.html',
            attributes: { 'data-id': 'p-SchemaNode-isUser' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-isUser-d66e6419',
            topics: [],
        },
        {
            title: ' joinParts ',
            href: 'p-SchemaNode-joinParts.html',
            attributes: { 'data-id': 'p-SchemaNode-joinParts' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-joinParts-d66e6427',
            topics: [],
        },
        {
            title: ' keys ',
            href: 'p-SchemaNode-keys.html',
            attributes: { 'data-id': 'p-SchemaNode-keys' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-keys-d66e6435',
            topics: [],
        },
        {
            title: ' label ',
            href: 'p-SchemaNode-label.html',
            attributes: { 'data-id': 'p-SchemaNode-label' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-label-d66e6443',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-SchemaNode-name.html',
            attributes: { 'data-id': 'p-SchemaNode-name' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-name-d66e6451',
            topics: [],
        },
        {
            title: ' nodePath ',
            href: 'p-SchemaNode-nodePath.html',
            attributes: { 'data-id': 'p-SchemaNode-nodePath' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-nodePath-d66e6459',
            topics: [],
        },
        {
            title: ' packageStatus ',
            href: 'p-SchemaNode-packageStatus.html',
            attributes: { 'data-id': 'p-SchemaNode-packageStatus' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-packageStatus-d66e6467',
            topics: [],
        },
        {
            title: ' parent ',
            href: 'p-SchemaNode-parent.html',
            attributes: { 'data-id': 'p-SchemaNode-parent' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-parent-d66e6475',
            topics: [],
        },
        {
            title: ' reverseLink ',
            href: 'p-SchemaNode-reverseLink.html',
            attributes: { 'data-id': 'p-SchemaNode-reverseLink' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-reverseLink-d66e6483',
            topics: [],
        },
        {
            title: ' schema ',
            href: 'p-SchemaNode-schema.html',
            attributes: { 'data-id': 'p-SchemaNode-schema' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-schema-d66e6491',
            topics: [],
        },
        {
            title: ' size ',
            href: 'p-SchemaNode-size.html',
            attributes: { 'data-id': 'p-SchemaNode-size' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-size-d66e6499',
            topics: [],
        },
        {
            title: ' tableDefinition ',
            href: 'p-SchemaNode-tableDefinition.html',
            attributes: { 'data-id': 'p-SchemaNode-tableDefinition' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-tableDefinition-d66e6508',
            topics: [],
        },
        {
            title: ' target ',
            href: 'p-SchemaNode-target.html',
            attributes: { 'data-id': 'p-SchemaNode-target' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-target-d66e6516',
            topics: [],
        },
        {
            title: ' type ',
            href: 'p-SchemaNode-type.html',
            attributes: { 'data-id': 'p-SchemaNode-type' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-type-d66e6524',
            topics: [],
        },
        {
            title: ' userEnumeration ',
            href: 'p-SchemaNode-userEnumeration.html',
            attributes: { 'data-id': 'p-SchemaNode-userEnumeration' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaNode-userEnumeration-d66e6532',
            topics: [],
        },
    ],
};

